import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CalculadoraComponent } from './calculadora/calculadora.component';
import { ReciboComponent } from './recibo/recibo.component';

const routes: Routes = [
  {
    path: '', redirectTo: 'calculadora', pathMatch: 'full'
  },
  {
    path: 'calculadora', component: CalculadoraComponent
  },
  {
    path: 'recibo/:razaoSocial/:funcionario/:hora50/:minuto50/:vTotal50/:hora80/:minuto80/:vTotal80/:hora100/:minuto100/:vTotal100/:hora120/:minuto120/:vTotal120/:horaFeriado/:minutoFeriado/:vTotalFeriado/:vTotalDsr/:vTotal/:diasTrabalhado/:vTotalDiasSalario', component: ReciboComponent
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
